import { userContext } from '../userManager';

/* Static Values */

export const apiUserTitlesGet = () => userContext.apiCall({ url: '/users/titles' });

export const apiCountriesGet = () => userContext.apiCall({ url: '/countries' });

export const apiRoles = () => userContext.apiCall({ url: '/roles' });

export const apiDocumentTypes = () => userContext.apiCall({ url: '/documents/types' });

export const apiCitiesGet = async (search) => {
  const { cities } = await userContext.apiCall({ url: '/cities', qs: { search } });
  return cities;
};

export const apiInvestibleUniverseGet = async (search, { types, recommended }) => {
  const qs = {
    types,
    recommended,
  };
  if (search) qs.name = search;
  const { investibleUniverse } = await userContext.apiCall({
    url: '/investible-universe',
    qs: { name: search, types, recommended },
  });

  return Object.values(investibleUniverse).reduce((acc, items) => [...acc, ...items], []);
};

export const apiAccountTypes = () => userContext.apiCall({ url: '/accounts/types' });

export const apiRiskProfilesTypes = () => userContext.apiCall({ url: '/risk-profiles' });

export const apiMandateTypes = () => userContext.apiCall({ url: '/mandate-types' });

export const apiRiskAppetiteProfiles = () =>
  userContext.apiCall({ url: '/risk-appetite-profiles' });

export const apiRandomWeights = () => userContext.apiCall({ url: '/random-weights' });

export const apiCrmOwners = () => userContext.apiCall({ url: '/crm/owners' });

export const apiInstrumentsIndex = () => userContext.apiCall({ url: '/instruments?type=index' });

export const apiInvestmentObjectiveTypes = () =>
  userContext.apiCall({ url: `/investment-objectives/types` });

export const apiFeeStructures = () => userContext.apiCall({ url: `/fee-structures` });

export const apiMaxDrawdownScenarios = () => userContext.apiCall({ url: `/maxdd-scenarios` });

export const apiAmlProfilesSectors = () => userContext.apiCall({ url: `/aml-profiles/sectors` });

export const apiAmlProfilesOccupations = () =>
  userContext.apiCall({ url: `/aml-profiles/occupations` });

export const apiAmlProfilesSavingsOrigins = () =>
  userContext.apiCall({ url: `/aml-profiles/savings-origins` });
